var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollabModalHeaderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5419_7414)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 2,
    width: 32,
    height: 32,
    rx: 3.47841,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2.5,
    width: 31,
    height: 31,
    rx: 2.97841,
    stroke: "url(#paint0_linear_5419_7414)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5419_7414)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4088 7.58115C20.2454 7.22689 19.8909 7 19.5007 7C19.1106 7 18.7561 7.22689 18.5927 7.58115L15.7236 13.8013L8.92136 14.6078C8.53393 14.6537 8.2086 14.9208 8.08804 15.2918C7.96748 15.6628 8.07371 16.0701 8.36015 16.335L13.3892 20.9857L12.0543 27.7043C11.9782 28.087 12.1317 28.4789 12.4473 28.7082C12.7629 28.9375 13.1831 28.9623 13.5235 28.7718L19.5007 25.426L25.4779 28.7718C25.8183 28.9623 26.2385 28.9375 26.5541 28.7082C26.8698 28.4789 27.0232 28.087 26.9472 27.7043L25.6122 20.9857L30.6413 16.335C30.9277 16.0701 31.034 15.6628 30.9134 15.2918C30.7928 14.9208 30.4675 14.6537 30.0801 14.6078L23.2778 13.8013L20.4088 7.58115Z",
    fill: "url(#paint1_linear_5419_7414)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5419_7414",
    x: 0.891195,
    y: 0.260796,
    width: 37.2176,
    height: 37.2176,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.869602
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.3044
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5419_7414"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5419_7414",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5419_7414",
    x1: 3.95977,
    y1: 28.0945,
    x2: 35.5,
    y2: 28.0945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C4ACF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69B7FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5419_7414",
    x1: 8.36842,
    y1: 24.8578,
    x2: 30.9624,
    y2: 24.8578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C4ACF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69B7FA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5419_7414"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(7.5 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollabModalHeaderIcon);
export default __webpack_public_path__ + "static/media/collabModalHeaderIcon.9800d8597c03d226187d6653e0407c5c.svg";
export { ForwardRef as ReactComponent };